/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import holderImage from "../../../img/property_placeholder.jpg";
import AssetKPIs from "../AssetKPIs";
import AssetImportButton from "../AssetImportButton";
import _ from "lodash";

import {
  getAssetStyleClass,
  getAssetTypeLabel,
  getAssetCashflowStyle,
  assetProfited
} from "../../../helpers";

import { Row, Badge } from "reactstrap";

export default class AssetSummary extends PureComponent {
  static propTypes = {
    assets: PropTypes.array.isRequired
  };

  toggleAssetLookup = () => {
    this.setState(nextState => ({
      showAssetLookup: !nextState.showAssetLookup
    }));
  };

  render() {
    const { assets } = this.props;
    return (
      <Row>
        {assets.length > 0 &&
          _.sortBy(assets, asset => {
            return assetProfited(asset);
          }).map((asset, i) => (
            <div
              className="col-sm-12 col-md-6 col-lg-6 col-xl-4"
              onClick={() => this.props.viewAsset(asset)}
              key={i}
            >
              <div className={`assets_block card-box-border-bottom border-${getAssetCashflowStyle(asset)}`}>
                <div className="assets_info">
                  <div className="assets_img">
                    <img
                      src={asset.images}
                      alt=""
                      onError={e => {
                        e.target.src = holderImage;
                      }}
                    />
                  </div>
                  <div className="assets_name">
                    <h4 className=" pt-0 pt-md-2">
                      {asset.address
                        .split(",")
                        .slice(0, 3)
                        .join(",")}
                    </h4>
                    <Badge
                      className="py-2 m-1 h-auto font-size-md"
                      color={getAssetStyleClass(asset.assetType)}
                    >
                      {getAssetTypeLabel(asset.assetType)}
                    </Badge>
                  </div>
                </div>
                <AssetKPIs asset={asset} />
              </div>
            </div>
          ))}
        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <AssetImportButton
            asCard={true}
            assetType={this.props.currentAssetType}
          />
        </div>
      </Row>
    );
  }
}
